import '../public/css/material-design-icons-iconfont/material-design-icons.css';
import Vue from 'vue';
import ActionCableVue from 'actioncable-vue';
import locale from 'dayjs/locale/pl';
import dayjs from 'dayjs';
import VueSanitize from 'vue-sanitize';
import { injectAuthInterceptor } from './api/axios';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './helpers/filters';

dayjs.locale('pl');

Vue.config.productionTip = false;

injectAuthInterceptor();
Vue.use(VueSanitize);

Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: 'error',
  connectionUrl: process.env.VUE_APP_WSS_BASE_URL,
  connectImmediately: false,
});

Vue.use(vuetify, {
  iconfont: 'mdi',
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
